export {
  startBackgroundLoad,
  ensureLoaded,
  isReady,
  getModule,
  getQuantumForge,
  getVersion,
  getMaxDimension,
  getMaxQudits,
  getMaxStateSize,
  getWasmMemoryBytes,
  setWasmBasePath,
  useQuantumForgeBuild,
  getAttribution,
  registerServiceWorker,
} from "./QuantumForgeLoader";
export { QuantumPropertyManager } from "./QuantumPropertyManager";
export type { PredicateSpec, QuantumRecorderHook } from "./QuantumPropertyManager";
export { QuantumRecorder } from "./QuantumRecorder";
export type { QuantumOperation, SerializedPredicate } from "./QuantumOperationLog";
export type { OpCode, BatchOp, BatchResult, OpNum } from "./quantum-forge-api.mjs";

/** Numeric opcode constants for tape encoding. Matches C++ OpCode enum. */
export const OP = {
  CYCLE: 0, SHIFT: 1, CLOCK: 2,
  X: 3, Z: 4, Y: 5,
  HADAMARD: 6, INVERSE_HADAMARD: 7,
  SWAP: 8, I_SWAP: 9,
  PHASE_ROTATE: 10,
  ROTATE_BASIS_PAIR: 11,
} as const;
